/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import cn from 'classnames';
import { Layout, Localization, Typography } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { useFormatStatusEventDateTime } from '../useFormatStatusEventDateTime';

const { Translate } = Localization;
const { Subtitle } = Typography;

const Styled = styled(Layout.Container)``;

const LoadingPointDesktop = ({ className, ticket, plantAddress, loadingStarted }) => {
  const formatTicketDateTime = useFormatStatusEventDateTime({ mode: 'datetime' });

  return (
    <Styled className={cn('loading-point', className)}>
      <Subtitle>
        <Translate stringId="loadingPoint" data-testid="loadingPointLabel" />
      </Subtitle>
      <div>
        <Translate stringId="plantName" data-testid="plantNameLabel" />
        {': '}
        <span data-testid="plantNameValue">{ticket?.origin?.description}</span>
      </div>
      <div>
        <Translate stringId="plantAddress" data-testid="plantAddressLabel" />
        {': '}
        <span data-testid="plantAddressValue">{plantAddress}</span>
      </div>
      <div>
        <Translate stringId="loadingScheduleStart" data-testid="loadingScheduleStartLabel" />
        {': '}
        <span style={{ whiteSpace: 'nowrap' }} data-testid="loadingScheduleStart">
          {formatTicketDateTime(loadingStarted)}
        </span>
      </div>
    </Styled>
  );
};

export default LoadingPointDesktop;
